module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_WPN PFCs FREE LEATHER_mobile.ab47b037.jpg";